import PropTypes from "prop-types";
import React, { Component } from "react";
import { Card } from "semantic-ui-react";
import AttachmentCard from "./AttachmentCard";

import "./attachmentCards.scss";

class AttachmentCards extends Component {
  static propTypes = {
    attachments: PropTypes.array,
    attachmentsPerRow: PropTypes.number
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { attachments } = this.props;
    return (
      <Card.Group
        stackable
        data-component="attachmentCards"
        itemsPerRow={this.props.attachmentsPerRow || 5}
      >
        {attachments &&
          attachments.length &&
          attachments.map(attachment => (
            <AttachmentCard
              key={`attachment-card-${attachment.id}`}
              attachment={attachment}
            />
          ))}
      </Card.Group>
    );
  }
}

export default AttachmentCards;
